import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { listSessions, themeGradient } from "@/lib/storage";

function fmtDate(ts) {
  if (!ts) return "";
  const d = new Date(ts);
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

export default function History() {
  const navigate = useNavigate();
  const sessions = useMemo(() => listSessions(), []);

  return (
    <div className="flex flex-col min-h-[100dvh] px-6 pt-6 pt-safe pb-12 pb-safe">
      <div className="flex items-center justify-between mb-8">
        <button
          data-testid="history-back"
          onClick={() => navigate("/")}
          className="relative z-10 -m-3 p-3 text-still-muted hover:text-still-fg transition-colors"
          aria-label="Back"
        >
          <ArrowLeft size={20} />
        </button>
        <div className="text-xs uppercase tracking-[0.3em] text-still-muted pointer-events-none">
          Your sessions
        </div>
        <div className="w-11" />
      </div>

      {sessions.length === 0 ? (
        <div className="flex-1 grid place-items-center px-4">
          <p className="font-serif italic text-xl text-center text-still-muted leading-relaxed max-w-[280px]">
            Your conversations will live here.
            <br />
            Just between you and Stillroom.
          </p>
        </div>
      ) : (
        <ul className="flex flex-col gap-1" data-testid="history-list">
          {sessions.map((s) => {
            const [g1, g2] = themeGradient(s.insight?.theme || "reflection");
            const preview =
              s.insight?.quote ||
              (s.messages || []).find((m) => m.role === "user")?.text ||
              "A quiet visit.";
            return (
              <li key={s.id}>
                <button
                  data-testid={`history-item-${s.id}`}
                  onClick={() => navigate(s.insight ? `/card/${s.id}` : `/chat/${s.id}?mode=${s.mode || "vent"}`)}
                  className="w-full text-left flex items-center gap-4 py-4 border-b border-still-border/60 hover:bg-white/[0.02] transition-colors px-2"
                >
                  <span
                    className="w-2.5 h-2.5 rounded-full shrink-0"
                    style={{ background: `linear-gradient(135deg, ${g1}, ${g2})` }}
                  />
                  <div className="flex-1 min-w-0">
                    <div className="font-serif italic text-still-fg text-base truncate">
                      {preview}
                    </div>
                    <div className="text-[11px] uppercase tracking-[0.2em] text-still-muted mt-1">
                      {fmtDate(s.createdAt)} · {s.mode === "figure" ? "figuring out" : "venting"}
                    </div>
                  </div>
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
